import { hasPermission } from '@/utils/permission'

function isAdminLike(u) {
  return Boolean(u?.is_superuser || u?.is_admin)
}

/** 是否拥有「查看全部他人任务」全局权限（不受矩阵限制） */
export function canViewAllTeamTasks(user) {
  if (!user) return false
  if (isAdminLike(user)) return true
  return (
    hasPermission(user, 'tasks.manage') ||
    hasPermission(user, 'tasks.view_team') ||
    hasPermission(user, 'global.admin')
  )
}

/** @deprecated 请结合 useTaskViewScope().canViewUserTasks；此处仅表示全局可看全部 */
export function canDrillMobileTeamTasks(user) {
  return canViewAllTeamTasks(user)
}

export function canConfigureTaskViewGrants(user) {
  if (!user) return false
  if (isAdminLike(user)) return true
  return hasPermission(user, 'tasks.manage') || hasPermission(user, 'roles.manage')
}

/** @deprecated 使用 canDrillMobileTeamTasks */
export function canViewMobileTeamTasks(user) {
  return canDrillMobileTeamTasks(user)
}

export function canPublishManualTasks(user) {
  if (!user) return false
  return (
    hasPermission(user, 'tasks.publish') ||
    hasPermission(user, 'tasks.manage') ||
    hasPermission(user, 'global.admin')
  )
}

/** 审核临时任务发布（涉及出库/外采/外发加工） */
export function canReviewManualTasks(user) {
  if (!user) return false
  if (isAdminLike(user)) return true
  return (
    hasPermission(user, 'tasks.manual.review') ||
    hasPermission(user, 'tasks.manage') ||
    hasPermission(user, 'global.admin')
  )
}
